import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    data() {
        return {
            recipeTypes: [
                { label: "Kuwertura", value: 0 },
                { label: "Produkt oblewany", value: 1 },
            ],
            recipeType: {
                couverture: 0,
                coatingProduct: 1
            },
            coatingProductType: {
                barrel: 1,
                clearChocolate: 2,
                chocolateWithIngredients: 3,
                figurine: 4,
                creams: 5,
                coatingProductInCoolingTunnel: 6,
            },
            materialTypes: {
                couverture: 1,
                rawMaterial: 2,
            }
        }
    },
    methods: {
        getRecipes: async function () {
            const getRecipesUrl = `${serverUrl}Recipe/GetRecipes`;
            return axios.get(getRecipesUrl)
        },
        createNewRecipe: async function (newRecipe) {
            const createNewRecipeUrl = `${serverUrl}Recipe/CreateRecipe`;
            return axios.post(createNewRecipeUrl, newRecipe)
        },
        editRecipe: async function (recipe) {
            const createNewRecipeUrl = `${serverUrl}Recipe/EditRecipe`;
            return axios.post(createNewRecipeUrl, recipe)
        },
        removeRecipe: async function (recipe) {
            const createNewRecipeUrl = `${serverUrl}Recipe/RemoveRecipe`;
            return axios.post(createNewRecipeUrl, recipe)
        },
        getCoatingRecipes: async function () {
            const getRecipesUrl = `${serverUrl}RecipeCoating/GetRecipes`;
            return axios.get(getRecipesUrl)
        },
    },
};
